// Small geo helpers.
// Haversine = great-circle distance on a sphere — fine for the < 100 km
// radii we filter on (the Earth is ~not flat enough to matter at this scale).

const R_KM = 6371.0088;

function toRad(d) { return (d * Math.PI) / 180; }

export function haversineKm(a, b) {
  if (!a || !b) return null;
  if (a.lat == null || a.lng == null || b.lat == null || b.lng == null) return null;
  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);
  const la1 = toRad(a.lat);
  const la2 = toRad(b.lat);
  const x = Math.sin(dLat / 2) ** 2 + Math.cos(la1) * Math.cos(la2) * Math.sin(dLng / 2) ** 2;
  return 2 * R_KM * Math.asin(Math.min(1, Math.sqrt(x)));
}

/**
 * Bounding box around (lat, lng) for `km` radius. Used as a cheap pre-filter
 * before the exact haversine refine — keeps the Supabase query selective
 * without needing PostGIS.
 */
export function bboxAround(lat, lng, km) {
  const latDelta = km / 110.574; // ~111 km per degree of latitude
  const lngDelta = km / (111.32 * Math.max(Math.cos(toRad(lat)), 0.000001));
  return {
    minLat: lat - latDelta,
    maxLat: lat + latDelta,
    minLng: lng - lngDelta,
    maxLng: lng + lngDelta,
  };
}

/** Human-friendly "2.3 km away" / "120 m away" / "45 km away". */
export function formatDistance(km) {
  if (km == null || !Number.isFinite(km)) return "";
  if (km < 1) return `${Math.round(km * 1000)} m away`;
  if (km < 10) return `${km.toFixed(1)} km away`;
  return `${Math.round(km)} km away`;
}
